import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiCustomLayoutComponent } from './ui-custom-layout/ui-custom-layout.component';
import { CoreLayoutFeatureToolbarModule } from '@nx-ratenow/core/layout/feature-toolbar';
import { CoreLayoutFeatureQuickpanelModule } from '@nx-ratenow/core/layout/feature-quickpanel';
import { CoreLayoutFeatureLayoutModule } from '@nx-ratenow/core/layout/feature-layout';
import { CoreLayoutFeatureSidenavModule } from '@nx-ratenow/core/layout/feature-sidenav';
import { CoreConfigPanelModule } from '@nx-ratenow/core/config-panel';

@NgModule({
  imports: [
    CommonModule,

    // LAYOUT
    CoreLayoutFeatureToolbarModule,
    CoreLayoutFeatureQuickpanelModule,
    CoreLayoutFeatureLayoutModule,
    CoreLayoutFeatureSidenavModule,

    CoreConfigPanelModule
  ],
  declarations: [UiCustomLayoutComponent],
  exports: [UiCustomLayoutComponent]
})
export class CoreLayoutFeatureCustomLayoutModule {}
